import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMapPin, FiPhone, FiMail, FiSend } from 'react-icons/fi';
import './Contacts.css';

const contactInfo = [
  { icon: <FiMapPin />, label: 'Адрес', value: 'г. Минск, Беларусь' },
  { icon: <FiPhone />, label: 'Телефон', value: '+375 29 634 80 36' },
  { icon: <FiMail />, label: 'Контактное лицо', value: 'Манько Кирилл Сергеевич' },
];

export default function Contacts() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 4000);
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <section className="section contacts" id="contacts">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="tag">СВЯЖИТЕСЬ С НАМИ</div>
          <div className="section-divider" style={{ marginTop: 16 }} />
          <h2 className="section-title">Начнём <span>проект</span>?</h2>
          <p className="section-subtitle">
            Расскажите о вашей задаче — мы свяжемся в течение одного рабочего дня.
          </p>
        </motion.div>

        <div className="contacts__grid">
          {/* Form */}
          <motion.form
            className="contacts__form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="contacts__field">
              <label className="contacts__label">Ваше имя</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Иван Иванов"
                className="contacts__input"
                required
              />
            </div>
            <div className="contacts__field">
              <label className="contacts__label">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="ivan@example.com"
                className="contacts__input"
                required
              />
            </div>
            <div className="contacts__field">
              <label className="contacts__label">Сообщение</label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Опишите вашу задачу..."
                className="contacts__input contacts__textarea"
                rows={5}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary contacts__submit">
              {sent ? '✓ Отправлено!' : (
                <><FiSend /> Отправить сообщение</>
              )}
            </button>
          </motion.form>

          {/* Info */}
          <motion.div
            className="contacts__info"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <div className="contacts__info-card card">
              <h3 className="contacts__info-title">Контактная информация</h3>
              <div className="contacts__info-items">
                {contactInfo.map((item, i) => (
                  <div key={i} className="contacts__info-item">
                    <span className="contacts__info-icon">{item.icon}</span>
                    <div>
                      <div className="contacts__info-label">{item.label}</div>
                      <div className="contacts__info-value">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="contacts__hours">
                <div className="contacts__hours-title">Время работы</div>
                <div className="contacts__hours-row">
                  <span>Пн — Пт</span>
                  <span className="contacts__hours-time">9:00 — 18:00</span>
                </div>
                <div className="contacts__hours-row">
                  <span>Сб — Вс</span>
                  <span className="contacts__hours-closed">Выходные</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
